import { useState, useCallback, useEffect } from 'react'

export default function useSimpleList(props) {
  const {
    requestList,
    requestCreate,
    requestUpdate,
    requestDestroy,
    defaultList,
    onSave,
  } = props

  const [list, setList] = useState([])
  const [responseError, setResponseError] = useState()
  const [pagination, setPagination] = useState()
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [currentItem, setCurrentItem] = useState(null)
  const [saving, setSaving] = useState(false)

  const getList = useCallback(async () => {
    if (!requestList) return setList(defaultList)

    setLoading(true)
    const response = await requestList()

    setLoading(false)
    if (response.error) return setResponseError(response)

    setPagination(response.meta?.pagination)
    return setList(response.data)
  }, [requestList, defaultList])

  useEffect(() => {
    getList()
  }, [getList])

  const onSaved = () => {
    setShowForm(false)
    setCurrentItem(null)

    if (onSave) onSave()
    getList()
  }

  const update = async (params) => {
    const resp = await requestUpdate(currentItem.id, params)

    setSaving(false)
    if (resp.error) return setResponseError(resp)

    return onSaved()
  }

  const create = async (params) => {
    const resp = await requestCreate(params)

    setSaving(false)
    if (resp.error) return setResponseError(resp)

    return onSaved()
  }

  const save = async (params) => {
    setSaving(true)

    if (!currentItem?.id) {
      return create(params)
    }

    return update(params)
  }

  const destroy = async (id) => {
    setSaving(true)
    const resp = await requestDestroy(id)

    setSaving(false)
    if (resp.error) return setResponseError(resp)

    return onSaved()
  }

  const selectItem = (item) => {
    setCurrentItem(item)
    setShowForm(true)
  }

  const onToggleForm = (show = false) => {
    if (!show) setCurrentItem(null)
    setResponseError(null)
    setShowForm(show)
  }

  return [
    list,
    {
      responseError,
      pagination,
      loading,
      showForm,
      currentItem,
      saving,
    },
    {
      save,
      destroy,
      selectItem,
      onToggleForm,
    },
  ]
}
